import { render, staticRenderFns } from "./AmputationPain.vue?vue&type=template&id=cdef963a&scoped=true"
import script from "./AmputationPain.vue?vue&type=script&lang=js"
export * from "./AmputationPain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdef963a",
  null
  
)

export default component.exports